import * as React from 'react';

import { CustomDialog } from 'components/Dialogs/CustomDialog';
import ButtonWithArrowIcon from 'components/Buttons/ButtonWithArrowIcon';
import { AnimatedLoaderModal } from 'components/Loaders/AnimatedLoader';

import styles from './styles.module.scss';
import { DocumentTypeEnum } from '../../../../common/document/enums/document-type.enum';

type InputProps = {
  isLoading: boolean;
  isSuccess: boolean;
  open: boolean;
  setOpen: (open: boolean) => void;
  fromDocument: {
    name: string;
    documentType: DocumentTypeEnum;
  };
  toDocument: {
    name: string;
    documentType: DocumentTypeEnum;
  };
  onConfirm: () => void;
};

export const ConfirmEditDocumentTypeDialog = ({
  isLoading = false,
  isSuccess = false,
  open = false,
  setOpen,
  onConfirm,
  fromDocument,
  toDocument,
}: InputProps) => {
  return (
    <CustomDialog open={open} setOpen={setOpen} title="Change Document Type">
      {isLoading ? (
        <AnimatedLoaderModal
          isLoading={!isSuccess}
          classNameWrapper={styles.loaderWrapper}
        />
      ) : (
        <div className={styles.root}>
          <div className={styles.description}>
            Are you sure you want to change the document type from{' '}
            <b>{fromDocument.name}</b> to <b>{toDocument.name}</b>?
          </div>
          <div className={styles.actions}>
            <ButtonWithArrowIcon onClick={onConfirm}>
              Confirm
            </ButtonWithArrowIcon>
          </div>
        </div>
      )}
    </CustomDialog>
  );
};
